import Icon1 from './1';
import Icon2 from './2';
import Icon3 from './3';
import Icon4 from './4';
import Icon5 from './5';
import Icon6 from './6';
import Icon7 from './7';
import Icon8 from './8';
import Icon9 from './9';
import Icon10 from './10';
import Icon11 from './11';
import Icon12 from './12';
import Icon13 from './13';


export default {
    Icon1,
    Icon2,
    Icon3,
    Icon4,
    Icon5, 
    Icon6,
    Icon7,
    Icon8,
    Icon9,
    Icon10,
    Icon11,
    Icon12,
    Icon13
}